import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="inline-edit"
// Swaps a read only label for a form so a value can be edited in place.
// Cancelling resets the form so any typed changes are discarded.
export default class extends Controller {
    static targets = ["label", "form", "input"]

    edit() {
        this.labelTarget.classList.add('hidden');
        this.formTarget.classList.remove('hidden');
        this.inputTarget.focus();
        this.inputTarget.select();
    }

    cancel() {
        this.formTarget.reset();
        this.formTarget.classList.add('hidden');
        this.labelTarget.classList.remove('hidden');
    }
}
